const prefix = "v1";
export default {
  document: {
    // 资料详情
    info: `${prefix}/document/document`,
    // 资料预览
    preview: `${prefix}/preview/info`,
    // 获取虚拟实验播放地址
    hmktVideoUrl: `${prefix}/preview/hmkt-video-url`,
    // 视频预览
    videoPreview: `${prefix}/preview/video`,
    // 备课资料预览
    bkPreview: `${prefix}/preview/infoBK`,
    // 资料加入备课
    documentAddBk: `${prefix}/document/document-add-bk`,
    // 获取在线编辑地址
    getDocumentOnlineEdit: `${prefix}/document/get_document_online_edit`,
    // 压缩包预览
    compoundvideopreview: `${prefix}/preview/compoundvideopreview`,
    // 获取资料下载地址
    download: `${prefix}/document/get-soft-downloadurl`,
    // 获取文件下载地址（多文件）
    downloadlist: `${prefix}/document/get-soft-downloadurl-list`,
    // 轮询下载地址
    training: `${prefix}/document/training`,
    // 多文件轮询
    getMultiTraining: `${prefix}/document/get-multi-training`,
    // 获取资料列表
    documents: `${prefix}/document/documentList`,
    // 获取实操实验资料列表
    lhsDocumentList: `${prefix}/document/lhsDocumentList`,
    // 更新资料浏览量
    addDocumentPv: `${prefix}/document/addDocumentPv`,
    // 获取专辑列表
    albums: `${prefix}/album/albumList`, // 获取专辑详情
    album: `${prefix}/album/album`, // 获取相关推荐数据
    // 更新专辑浏览量
    addAlbumPv: `${prefix}/album/addAlbumPv`,
    listAlbumRecommend: `${prefix}/album/listAlbumRecommend`,
    // 获取专辑成套下载地址
    getAlbumDownLoadUrl: `${prefix}/album/get-album-downloadurl`,
    // 获取NB实验资料预览信息
    nbPreview: `${prefix}/preview/nb-preview`,
    // rbm预览
    rbmPreview: `${prefix}/preview/rbm-preview`,
    // 获取编辑推荐数据
    listEditorRecommend: `${prefix}/album/listEditorRecommend`,
    // 获取资料详情页的资源推荐列表
    getDocumentRecommend: `${prefix}/document/get-document-recommend-list`,
    // 获取理化生资料详情页的资源推荐列表
    getDocumentLhsRecommendList: `${prefix}/document/get-documentLhs-recommend-list`,
    documentAllType: `${prefix}/document/documentAllType`,
    documentBkInfo: `${prefix}/document/documentBkInfo`,
    // 获取研修资料预览信息
    yxPreview: `${prefix}/preview/yx-preview`,
    // 获取研修视频播放地址
    yxVideoUrl: `${prefix}/preview/yx-video-url`,
    // 获取教材节点关联知识点资料列表
    getMaterialNodeKnowledgeDocumentList: `${prefix}/document/getMaterialNodeKnowledgeDocumentList`,
    //获取用户的详情页打开方式
    getDocDetailOpenMethod: `${prefix}/document/getDocDetailOpenMethod`,
    //设置用户的详情页打开方式
    setDocDetailOpenMethod: `${prefix}/document/setDocDetailOpenMethod`,
    // 获取配套资料接口
    getRelatedDocumentList: `${prefix}/document/getRelatedDocumentList`,
    // 根据资料文件id获取大纲
    getFileOutline: `${prefix}/document/get-file-outline`,
    //创建临时链接地址
    labTempLink: `${prefix}/lab-temp-links/create`,
    //获取临时链接的预览信息
    labPrueViewInfo: `${prefix}/lab-temp-links/info`,
  },
  album: {
    info: `${prefix}/album/album-info`,
    // 获取专辑详情推荐专辑列表
    albumInfoRecommendAlbumList: `${prefix}/album/album-info-recommend-album-list`,
  },
  feedback: {
    // 添加意见反馈到rbm
    putUserQuestion: `${prefix}/question/put-resource-question-rbm`,
    //分页获取提交到RBM处的挑错建议
    getResourceQuestionList: `${prefix}/question/get-resource-question-list`,
  },
  collect: {
    // 添加收藏
    add: `${prefix}/work/put-user-favorite`,
    // 取消收藏
    cancel: `${prefix}/work/cancel-user-favorite`,
  },
  work: {
    // 用户卡片
    cards: `${prefix}/work/get-user-cards`,
    // 取消收藏
    cancelFavorite: `${prefix}/work/cancel-user-favorite`,
    // 获取用户功能列表
    functions: `${prefix}/work/get-user-functions`,
    // 获取用户模块
    modules: `${prefix}/work/get-user-modules`,
    // 获取用户教材
    textbooks: `${prefix}/work/get-user-books`,
    // 获取用户收藏
    favorites: `${prefix}/work/get-user-favorite`,
    // 获取用户下载
    downloads: `${prefix}/work/get-user-download`,
    // 添加教材
    addTextbook: `${prefix}/work/put-user-book`,
    // 获取用户课程
    getCourse: `${prefix}/work/get-user-courses`,
    // 添加用户课程
    addCourse: `${prefix}/work/put-user-course`,
    // 获取用户课程(含教材信息)
    getCourseBook: `${prefix}/work/get-user-courses-book`,
    // 用户功能
    features: `${prefix}/work/get-system-functions`,
    // 偏好设置
    setFeatures: `${prefix}/work/update-user-functions`,
    // 删除教材
    deleteBook: `${prefix}/work/delete-user-book`,
    // 删除课程
    deleteUserCourse: `${prefix}/work/delete-user-course`,
    // 批量删除课程
    deleteUserCourses: `${prefix}/work/delete-user-courses`,
    // 批量删除课程前的提示判断
    deleteUserCoursesIsTip: `${prefix}/work/delete-user-courses-isTip`,
    //批量更新用户课程
    updateUserCourseList: `${prefix}/work/update-user-course`,
    // 对接备课，同步此用户的课程
    syncUserCourses: `${prefix}/work/sync-user-courses`,
    // 获取E备课当前课程下最近操作的文件
    getUserLatestFilesBk: `${prefix}/work/get-user-latestFiles-bk`,
    // 获取资源推荐卡片
    getResourceRecommendCard: `${prefix}/work/get_resourceRecommend_card`,
    // 获取用户最近操作的目录id
    getUserFolderLastSelected: `${prefix}/work/getUserFolderLastSelected`,
    // 获取用户数据看板
    getUserData: `${prefix}/work/get-user-data`,
    // 获取教学日历资料推荐
    getTeachResourceList: `${prefix}/work/get-teach-resource-list`,
    // 获取我的权益信息
    getUserEquity: `${prefix}/work/get-user-equity`,
    // 获取集备代办列表
    getUserCollectiveTasks: `${prefix}/work/get-user-collective-tasks`,
    // 添加虚拟实验观看记录
    putHmktUsageLog: `${prefix}/work/put-hmkt-usage-log`,
    // 获取用户功能权限
    getUserModuleAuth: `${prefix}/work/get-user-module-auth`,
    // 更新用户功能列表排序
    updateUserFunctionSort: `${prefix}/work/update-user-function-sort`,
    getWeekTeachingCalendar: `${prefix}/work/get-week-teaching-calendar`,
  },
  settle: {
    // 获取资料支付信息
    getPayInfo: `${prefix}/settle/get-pay-info`,
    // 资料结算
    documentSettle: `${prefix}/settle/document-settle`,
    // 获取资料支付信息
    getDocumentPayInfo: `${prefix}/settle/get-document-pay-info`,
    getAlbumPayInfo: `${prefix}/settle/get-album-pay-info`,
    // 专辑成套结算
    albumSettle: `${prefix}/settle/album-settle`,
  },
  auth: {
    // 用户信息 没有版本前缀
    userInfo: `/auth/userinfo`,
    // 退出
    logout: "/auth/logout",
    //用户是否有可进入网校通权限
    userRoleStatus: "/auth/user-role",
  },
  nav: {
    // 获取资料范围
    range: `${prefix}/nav/examinationSyllabus`,
    // 获取资料类别
    categories: `${prefix}/nav/resourceCategories`,
    // 获取资料【类型】筛选项列表-3.1标签
    categoriesV4: `${prefix}/nav/resourceCategoriesV4`,
    // 获取资料【类型】筛选项列表-仿真实验室
    resourceCategoriesLHS: `${prefix}/nav/resourceCategoriesLHS`,
    // 获取资料场景
    types: `${prefix}/nav/resourceTypes`,
    // 获取商业等级
    classes: `${prefix}/nav/commercialClasses`,
    // 获取搜索页商业等级列表
    commercialLevelSearch: `${prefix}/search/commercialLevelSearch`,
    // 获取年份
    years: `${prefix}/nav/yeas`,
    // 获取教材目录
    catalog: `${prefix}/nav/catalog`,
    // 获取文档类型
    fileTypes: `${prefix}/nav/documentTypes`,
    // 获取试题试卷下的特殊类型
    option: `${prefix}/nav/specialOption`,
    // 获取备考列表目录
    examsCatalog: `${prefix}/nav/examsCatalog`,
    // 获取校本备考目录列表
    examsAndCharacterCatalogs: `${prefix}/nav/examsAndCharacterCatalogs`,
    // 获取备考列表目录V4
    examsCatalogV4: `${prefix}/nav/examsCatalogV4`,
    // 获取升学复习列表目录
    reviewCatalog: `${prefix}/nav/reviewCatalog`,
    // 获取升学复习列表目录V4---校本
    reviewCatalogSchoolV4: `${prefix}/nav/reviewCatalogSchoolV4`,
    // 获取知识点列表目录
    knowledgeCatalog: `${prefix}/nav/knowledgePointsCatalog`,
    // 获取升学考试列表目录
    reviewCatalogV4: `${prefix}/nav/reviewCatalogV4`,
    // 获取【同步素材】筛选项列表
    materialTypes: `${prefix}/nav/materialTypes`,
    // 获取专辑的更新状态
    updateStatus: `${prefix}/nav/updateStatus`,
    // 获取学校的级别
    schoolLevel: `${prefix}/nav/schoolLevel`,
    // 获取学科特色列表
    subjectCharacteristics: `${prefix}/nav/subjectSpecialCatalogV4`,
    // 云资源整体优化--Tab页筛选条件
    navFilterTabs: `${prefix}/nav/navFilterTabs`,
    // 获取试卷tab页目录V4
    testPaperCatalogV4: `${prefix}/nav/testPaperCatalogV4`,
    // 获取学科特色tab页目录V4
    subjectSpecialCatalogV4: `${prefix}/nav/subjectSpecialCatalogV4`,
    // 生成同步内容URL
    getSyncUrl: `${prefix}/nav/get-sync-url`,
    // 生成云资源URL
    getTechUrl: `${prefix}/nav/get-tech-url`,
    // 、获取筛选年份--仿真实验室内
    yearsFZ: `${prefix}/nav/yearsFZ`,
    // 资源库备考
    zyk: `${prefix}/nav/get-zyk-exam-url`,
    // 上好课链接
    shk: `${prefix}/nav/get-shk-exam-url`,
  },
  base: {
    areas: `${prefix}/basic/areas`,
    // 仿真实验室：根据上级地区ID获取一级子地区列表
    areasFZ: `${prefix}/basic/areasFZ`,
    // 根据学段获取学科列表
    subjects: `${prefix}/school-auth/stageAndSubjects`,
    // 获取版本
    versions: `${prefix}/basic/versions`,
    // 获取教材
    textbooks: `${prefix}/basic/textbooks`,
    // 根据条件查询学校与机构列表，支持翻页。
    getOrganizationsByConditions: `${prefix}/basic/getOrganizationsByConditions`,
    // 获取组织列表
    organizations: `${prefix}/introduce/organizations`,
    // 获取学段学科
    stages: `${prefix}/school-auth/stageListAndSubjects`,
    // 获取实操实验学段学科
    scsyStageAndSubjectList: `${prefix}/school-auth/experimentStageAndSubjectList`,
    // 获取实验有权限的学段学科
    experimentStageAndSubjectList: `${prefix}/school-auth/experimentStageAndSubjectList`,
    // `experiment-category-list`
    // 获取学校有权限的学段
    schoolStages: `${prefix}/school-auth/stageList`,
    // 获取学校信息
    schoolInfo: `${prefix}/school-auth/school-info`,
    // 年级列表
    grades: `${prefix}/basic/grades`,
    // 学期列表
    // 获取学期列表
    terms: `${prefix}/basic/terms`,
    // 学年列表
    yearrange: `${prefix}/nav/year-range`,
    // 获取实操实验目录树
    scsyCatalog: `${prefix}/nav/experiment-catalog`,
    // 获取实验类型列表
    experimentCategoryList: `${prefix}/nav/experiment-category-list`,
    // 获取没有权限的学段学科
    basicStage: `${prefix}/basic/stages`,
    // 获取搜索页，有网校通权限的学段学科
    searchStageAndSubjectList: `${prefix}/school-auth/searchStageAndSubjectList`,
    // 获取学校学段信息
    schoolStages: `${prefix}/school-auth/schoolStageList`,
    // 获取学校学段信息（含网校通开通学段和学校本身学段信息）
    schoolAndAuthStageList: `${prefix}/school-auth/schoolAndAuthStageList`,
    // 时间筛选项
    timeTypes: `${prefix}/nav/timeTypes`,
    // 获取课程详情
    course: `${prefix}/basic/course`,
    // 获取教材详情
    textbook: `${prefix}/basic/textbookInfo`,
    // 获取用户画像
    getUserImage: `${prefix}/basic/getUserImage`,
    // 获取备课文件夹目录列表
    getBkFolderList: `${prefix}/basic/getBkFolderList`,
    // 获取指定地区课程下的教材主次版本,第一条数据是主版本，第二条是次版本
    getTextBookVersionByCourseIdAndAreaId: `${prefix}/basic/getTextBookVersionByCourseIdAndAreaId`,
    // 根据教材版本ID获取上好课教材列表
    syncTextbooks: `${prefix}/basic/syncTextbooks`,
  },
  search: {
    // 获取热搜索词列表
    hotSearch: `${prefix}/search/hotSearch`,
    // 获取热搜词列表--根据学段学科
    hotSearchSite: `/${prefix}/search/hotSearchSite`,
    // 搜索联想词显示
    searchRecommends: `${prefix}/search/searchRecommends`,
    // 搜索资料列表
    searchDocumentList: `${prefix}/document/searchDocumentList`,
    // 搜索用户收藏列表
    listUserCollect: `${prefix}/search/listUserCollect`,
  },
  modules: {
    // 获得系统模块
    getSystemModules: `${prefix}/work/get-user-modules`,
    // 更新用户模块
    updateUserModules: `${prefix}/work/update-user-modules`,
    // 获取更多应用
    getUserMoreApp: `${prefix}/work/get-user-moreApp`,
  },
  system: {
    // 获取更新日志
    getSysUpdateLogs: `${prefix}/system/get-sys-update-logs`,
  },
  upload: {
    image: `${prefix}/upload/upload-image`,
    file: `${prefix}/upload/upload-file`,
    token: `${prefix}/upload/get-oss-token`,
  },
  schoolbase: {
    // 获取文件下载地址（校本资源库）
    schoolbasedown: `${prefix}/schoolbase/get-downloadurl`,
    // 资料预览（校本资源库）
    preview: `${prefix}/preview/xiaoben-preview`,
    // 视频预览（校本资源库）
    videoPreview: `${prefix}/preview/xiaoben-vieo`,
    // 压缩包预览（校本资源库）
    compoundvideopreview: `${prefix}/preview/xiaoben-compound-vieo`,
    // 获取资料详情（校本资源库）
    getresource: `${prefix}/schoolbase/get-resource`,
    // 添加资料（校本资源库）
    putresource: `${prefix}/schoolbase/put-resource`,
    // 获取资料列表（校本资源库）
    schoolbasedocuments: `${prefix}/schoolbase/resource-list`,
    // 更新资料
    updataresource: `${prefix}/schoolbase/update-resource`,
    //获取学校统计数据概览
    schoolstatistics: `${prefix}/schoolbase/get-school-statistics`,
    //获取学科统计数据
    subjectstatistics: `${prefix}/schoolbase/get-subject-statistics`,
    //获取教师统计数据
    teacherstatistics: `${prefix}/schoolbase/get-teacher-statistics`,
    // 数据导出
    statisticsLoad: `${prefix}/schoolbase/statistics_load`,
    // 获取当前用户上传数据
    getUserResource: `${prefix}/schoolbase/get-user-resource`,
    // 删除资源
    deleteResource: `${prefix}/schoolbase/delete-resource`,
    // 获取校本资源中，搜索下拉筛选项
    getFilteredOptions: `${prefix}/schoolbase/getFilteredOptions`,
    // 审核
    review: {
      // 获取审核资源列表
      reviewResourceList: `${prefix}/schoolbase/review-resource-list`,
      // 资源审核
      resourceReview: `${prefix}/schoolbase/resource-review`,
      reviewStatusList: `${prefix}/schoolbase/review-status-list`,
      reviewCourseList: `${prefix}/schoolbase/review-course-list`,
      // 获取学校审核状态
      getReviewSet: `${prefix}/schoolbase/get-review-set`,
    },
    // 提示审核人处理待审资源
    remindReviewResource: `${prefix}/schoolbase/remind-review-resource`,
    // 获取校本页面-tabs列表
    tabs: `${prefix}/schoolbase/tabs`,
    // 获取学校后台配置各功能状态
    getSchoolConfigStatus: `${prefix}/schoolbase/getSchoolConfigStatus`,
  },
  afterService: {
    // 获取课后服务分类
    afterTypeList: `${prefix}/nav/after-type-list`,
    // 获取课后专辑列表
    afterAlbumList: `${prefix}/album/after-album-list`,
    // 获取专辑详细
    getAlbumDetail: `${prefix}/album/album`,
  },
  school: {
    // 获取本地名校推荐列表
    getLocalSchoolList: `${prefix}/zyk/mx/get-local-school-list`,
    // 获取我的关注列表
    getSchoolFollowList: `${prefix}/zyk/mx/get-school-follow-list`,
    // 获取学校详情
    getSchoolDetail: `${prefix}/zyk/mx/get-school-detail`,
    // 添加学校关注
    addSchoolFollow: `${prefix}/zyk/mx/add-school-follow`,
    // 取消学校关注
    cancelSchoolFollow: `${prefix}/zyk/mx/cancel-school-follow`,
    // 获取名校列表（关键字搜索）
    getSchoolList: `${prefix}/zyk/mx/get-school-list`,
  },
  rights: {
    // 获取权益列表
    getUserRights: `${prefix}/user-rights/get-user-rights`,
    // 权益中心--获取用户信息
    userinfoRights: `${prefix}/user-rights/userinfo-rights`,
  },
  sync: {
    // 获取课程列表
    getCourseList: `${prefix}/sync/get-course-list`,
    getVersionList: `${prefix}/sync/get-version-list`,
    // 同步内容教学节点树,
    syncTeachCatalogs: `${prefix}/sync/sync-teach-catalogs`,
    getCourseRecommendList: `${prefix}/sync/get-course-recommend-list`,
    // 同步内容教学节点栏目
    syncTeachMenus: `${prefix}/sync/sync-teach-menus`,
    // 获取推荐栏目资料列表
    getRecommendCategoryList: `${prefix}/sync/get-recommend-category-list`,
    // 获取栏目资料列表
    getCategoryDocumentList: `${prefix}/sync/get-category-document-list`,
    // 获取子目录资料列表
    getChildResourceList: `${prefix}/sync/get-child-resource-list`,
    // 获取详情页资料推荐
    getRecommendResourceList: `${prefix}/sync/get-recommend-resource-list`,
    // 获取同步内容学年列表
    syncYearRange: `${prefix}/sync/sync-year-range`,
    // 获取 tab 列表
    syncTabsStatus: `${prefix}/sync/get-tab-status`,
  },
  exam: {
    // 获取备考目录
    examTeachCatalogs: `${prefix}/exam/exam-teach-catalogs`,
    // 备考下的栏目资料列表
    getCategoryDocumentList: `${prefix}/exam/exam-category-document-list`,
    // 获取节点下栏目及资料列表
    getTeachDocumentList: `${prefix}/exam/get-teach-document-list`,
    // 课程推荐资料列表
    getCourseRecommendList: `${prefix}/exam/get-course-recommend-list`,
    // 获取子节点下的数据
    getTreeChildList: `${prefix}/exam/get-child-document-list`,
    // 获取详情页资料推荐列表
    getDocumentRecommendList: `${prefix}/exam/get-document-recommend-list`,
    // 获取备考栏目资料列表
    getCategoryList: `${prefix}/exam/get-category-document-list`,
    // 获取备考栏目列表
    getExamTeachMenus: `${prefix}/exam/exam-teach-menus`,
  },
  // 学校数据看板
  schoolData: {
    // 获取备课文件科目对比
    getLectureFileData: `${prefix}/schoolboard/lecture-file-subject`,
    // 集备任务科目对比
    getLectureTaskData: `${prefix}/schoolboard/lecture-task-subject`,
    // 获取学校指标数据
    getMetricData: `${prefix}/schoolboard/metric-data`,
    // 资源下载使用类型对比
    getTypeDownload: `${prefix}/schoolboard/resource-type-download`,
    // 校本上传科目对比
    getSchoolUploadData: `${prefix}/schoolboard/school-subject-upload`,
    // 资源下载科目数量对比
    getSubjectDownload: `${prefix}/schoolboard/subject-download`,
    // 获取教学动态数据
    getTeachingData: `${prefix}/schoolboard/teaching-news`,
    // 是否有权限学校
    getSchoolAuth: `${prefix}/schoolboard/white-school`,
  },
  // 英语词汇
  endict: {
    // 根据id查询单词
    wordIdDetail: `${prefix}/endict/word-id-detail`,
    // 根据名称查询单词
    wordNameDetail: `${prefix}/endict/word-name-detail`,
    // 单词搜索
    wordSearch: `${prefix}/endict/word-search`,
    // 获取章节词汇列表
    catalogWordList: `${prefix}/endict/catalog-word-list`,
  },
  // 实验数据看板
  labDatakanban: {
    // 播放信息保存
    savePlayLog: `${prefix}/lab-datakanban/save-play-log`,
    // 获取仿真实验室使用数据看板页实体
    getLabUseDatakanban: `${prefix}/lab-datakanban/get-lab-use-datakanban`,
    // 获取仿真实验室使用数据详情页实体
    getLabUseDataInfo: `${prefix}/lab-datakanban/get-lab-use-data-info`,
    // 仿真实验室数据看板-数据导出
    exportPlayLog: `${prefix}/lab-datakanban/export-play-log`,
    // 保存访问时长-NB实验
    saveVisitDurationLog: `${prefix}/lab-datakanban/save-visit-duration-log`,
    // 获取NB实验访问时长数据看板页实体
    getLabVisitDurationDatakanban: `${prefix}/lab-datakanban/get-lab-visit-duration-datakanban`,
    // 获取NB实验用户访问时长详情汇总列表
    getLabVisitDurationDetailList: `${prefix}/lab-datakanban/get-lab-visit-duration-detail-list`,
    // NB数据看板-数据导出
    exportVisitLog: `${prefix}/lab-datakanban/export-visit-log`,
  },
  zyk: {
    // 全局页面
    globalPages: `${prefix}/zyk/global-pages`,
    // 根据页面id获取对应的筛选条件
    filtersAndTree: `${prefix}/zyk/filters-and-tree`,
    // 具体页面的资料列表查询（传递pageId）
    documentList: `${prefix}/zyk/documentList`,
    // 获取绝密年级和学期列表
    getGradeAndTermList: `${prefix}/zyk/secret/get-grade-and-term-list`,
    // 获取绝密地区列表
    getAreaList: `${prefix}/zyk/secret/get-area-list`,
    // 更新绝密年级和学期
    updateLastUsedGradeAndTerm: `${prefix}/zyk/secret/update-last-used-grade-and-term`,
  },
  aikx: {
    // 获取AI科学模块-页面布局配置项
    aiSciencePageLayout: `${prefix}/aikx/ai-science-page-layout`,
    // 获取AI科学 - 资料列表查询
    documentList: `${prefix}/aikx/documentList`,
    // 获取资料详情页的资源推荐列表
    documentRecommendList: `${prefix}/aikx/document-recommend-list`,
  },
  airead: {
    // 获取学段学科列表
    getStageSubjectList: `${prefix}/airead/get-stage-subject-list`,
    // 获取年级列表
    getGradeList: `${prefix}/airead/get-grade-list`,
    // 获取阅读目录树
    getCatalogList: `${prefix}/airead/get-catalog-list`,
    // 获取课型列表
    getCategoryList: `${prefix}/airead/get-category-list`,
    // 获取用户最近使用课程
    getUserUsedCourse: `${prefix}/airead/get-user-used-course`,
    // 更新或添加用户最近使用课程
    updateOrAddUsedCourse: `${prefix}/airead/updateOrAddUsedCourse`,
    // 获取资料列表
    documentList: `${prefix}/airead/resourceList`,
    // 获取专辑详情
    getAlbumInfo: `${prefix}/airead/get-album-info`,
    getRecommendList: `${prefix}/airead/get-recommend-list`,
  },
  basic: {
    // 根据产品Id获取课程列表
    getCourseList: `${prefix}/basic/get-course-list`,
    // 根据产品Id获取最后使用课程信息
    getLastUsedCourse: `${prefix}/basic/get-last-used-course`,
    // 更新或添加用户最近使用课程信息
    updateLastUsedCourse: `${prefix}/basic/update-last-used-course`,
  },
  paper: {
    info: `${prefix}/shk/paper/get-paper-info`,
    similar: `${prefix}/shk/paper/get-similar-paper-info`,
    difficulty: `${prefix}/shk/paper/get-paper-difficulty-list`,
    questionList: `${prefix}/shk/paper/get-question-list`,
    quesDifficulty: `${prefix}/shk/paper/get-ques-difficulty-list`,
    download: `${prefix}/shk/paper/paper-download`,
  },
  jsonp: {
    userLoginStatus: `https://${
      window.location.host.indexOf("test-wxt") > -1 ? "tsso" : "sso"
    }.xkw.com/user/info`,
  },
  paper: {
    info: `${prefix}/shk/paper/get-paper-info`,
    resourceInfo: `${prefix}/shk/paper/get-paper-resource-info`,
    reviewUrls: `${prefix}/preview/paper-preview-urls`,
    similar: `${prefix}/shk/paper/get-similar-paper-info`,
    difficulty: `${prefix}/shk/paper/get-paper-difficulty-list`,
    questionList: `${prefix}/shk/paper/get-question-list`,
    quesDifficulty: `${prefix}/shk/paper/get-ques-difficulty-list`,
    download: `${prefix}/shk/paper/paper-download`,
    reDownload: `${prefix}/shk/paper/paper-re-download`,
  },
};
